import { useLazyQuery } from '@apollo/client';
import { GET_BULK_WEEKLY_WORKLIST_DATA } from '@bechtel/client-gql';
import { PagingRowNumberInput, WeeklyWorkInput, WeeklyWorkListBulk } from '@bechtel/types';

export function useBulkWeeklyWorklist(fetchFromNetwork?: boolean) {
  const response = useLazyQuery<
    { weeklyWorkListBulk: WeeklyWorkListBulk },
    {
      input: WeeklyWorkInput;
      paging?: PagingRowNumberInput;
    }
  >(
    GET_BULK_WEEKLY_WORKLIST_DATA,
    fetchFromNetwork
      ? {
          notifyOnNetworkStatusChange: true,
          fetchPolicy: 'network-only',
        }
      : {
          notifyOnNetworkStatusChange: true,
        }
  );
  return response;
}
